import React, { useEffect, useState } from "react";

export default function AddBatch() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Config load error:", err));
  }, []);

  const handleAddBatch = async () => {
    if (!config) {
      alert("Config not loaded yet!");
      return;
    }

    const batchName = prompt("Enter Batch Name");

    if (!batchName || batchName.trim() === "") {
      alert("Batch name is required!");
      return;
    }

    try {
      const response = await fetch(
        `${config.BASE_URL}${config.ADD_BATCH}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ batch_name: batchName }),
        }
      );

      const data = await response.json();

      if (data.success) {
        alert(`Batch added!\nID: ${data.batch_id}\nName: ${batchName}`);
      } else {
        alert("Failed: " + data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Error connecting to server");
    }
  };

  return (
    <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  }}
>
  <button
    onClick={handleAddBatch}
    style={{
      padding: "10px 20px",
      background: "#0a7cff",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      textAlign: "center",
    }}
  >
    Add Batch
  </button>
</div>

  );
}
